import { FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import { useCallback, useState } from 'react';
import { STRIPE_LOGO_URL, SUPPORTED_COUNTRIES } from './constants';
import {
  ActionButton,
  CardDescription,
  CardTitle,
  CountrySelect,
  StripeCard,
  StripeContainer,
  StripeLogo,
} from './styled';
import { useStripeAccountOnboardUrl } from './use-stripe-account-onboard-url';

export const StripeSetupBanner = () => {
  const { redirectToStripeOnboard, loading } = useStripeAccountOnboardUrl();
  const [country, setCountry] = useState<string>('US');

  const handleConnect = useCallback(() => {
    void redirectToStripeOnboard(country);
  }, [redirectToStripeOnboard, country]);

  return (
    <StripeContainer>
      <StripeCard>
        <Stack gap={1}>
          <StripeLogo src={STRIPE_LOGO_URL} alt="Stripe" />

          <CardTitle>Connect Your Stripe Account</CardTitle>

          <CardDescription>
            Connect your Stripe Express account to receive membership payments directly to your
            bank account. You&apos;ll be redirected to Stripe to complete the onboarding process.
          </CardDescription>

          <CountrySelect>
            <FormControl size="small" fullWidth>
              <InputLabel id="stripe-country-label">Country</InputLabel>
              <Select
                labelId="stripe-country-label"
                id="stripe-country-select"
                value={country}
                label="Country"
                onChange={(e) => setCountry(e.target.value)}
              >
                {SUPPORTED_COUNTRIES.map((c) => (
                  <MenuItem key={c.value} value={c.value}>
                    {c.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </CountrySelect>

          <ActionButton variant="contained" onClick={handleConnect} disabled={loading}>
            {loading ? 'Connecting...' : 'Connect with Stripe'}
          </ActionButton>
        </Stack>
      </StripeCard>
    </StripeContainer>
  );
};
